import CertsListEmailHistory from './CertsListEmailHistory';

export default CertsListEmailHistory;
